import PropTypes from 'prop-types';

export const timeLineDataPT = PropTypes.arrayOf(PropTypes.exact({
  date: PropTypes.string,
  id: PropTypes.number,
  title: PropTypes.string,
}));

